import IndiceModal from "./IndiceModal";
export default IndiceModal;